import { type UserRoles } from '@bibeltv-leseplaene/api'
import { type RouteLocationNormalized } from 'vue-router'

import { useLoginRedirect } from '~/composables/useLoginRedirect'

export async function checkUserAuth(allowedRoles: UserRoles[]) {
  const auth = useAuth()
  const keycloak = useKeycloak()
  const mbtv = useMBTV()

  await keycloak.waitForKeycloak()
  await mbtv.waitForMBTV()
  await auth.waitForAuth()

  if (
    !auth
    || !auth.session.user
    || (!allowedRoles.some((allowedRole) =>
      auth.session.user?.roles.some((role) => role.name === allowedRole),
    )
      && allowedRoles.length !== 0)
  ) {
    return { allowed: false, auth: auth.isAuthenticated && auth.session.status === 'authenticated' }
  }

  return { allowed: true, auth: auth.isAuthenticated }
}

export function getRedirectLocation() {
  const auth = useAuth()

  if (!auth.isAuthenticated || auth.session.status === 'unauthenticated') return '/loginSelection'
  if (!auth.session.isCreator && !auth.session.isModerator) return '/creator'
  else return '/leseplaene'
}

export async function enforceAuth(route: RouteLocationNormalized) {
  if (route.name && route.name.toString().startsWith('login')) {
    const auth = await checkUserAuth(['CREATOR', 'MODERATOR'])
    if (auth.allowed && auth.auth && route.name && route.name.toString().startsWith('login'))
      return navigateTo(getRedirectLocation())
    else if (auth.auth) {
      return navigateTo('/creator')
    }
  }

  if (Array.isArray(route.meta.auth)) {
    const check = await checkUserAuth(route.meta.auth as UserRoles[])

    if (!check.allowed) {
      // Only worth remembering when the login is missing. With a valid session
      // but the wrong role the target would just deny again after logging in.
      if (!check.auth) useLoginRedirect().remember(route.fullPath)

      return navigateTo(getRedirectLocation())
    }
  }

  if (route.name === 'creator') {
    const auth = useAuth()

    if (auth.session.isCreator || auth.session.isModerator) {
      return navigateTo('/leseplaene')
    }
  }
}

export default defineNuxtRouteMiddleware(async (to) => {
  return await enforceAuth(to)
})
